import { SettlementForm } from 'es6/models/settlement-form'
import { user } from './user'

/**
 * Инициализация модели города
 */
export const settlement = new SettlementForm(null, { user })
settlement.attachMinSumTrigger()
if (window.app && window.app.settlementJson) {
  settlement.set(window.app.settlementJson)
}
